import InternationalOrganizationsCard from './InternationalOrganizationsCard';

export default InternationalOrganizationsCard;